import React, { useRef, useEffect } from "react";
import * as d3 from "d3";

interface Props {
  home: number;
  away: number;
  width: number;
  height: number;
}

export type Data = { name: string; value: number };

const PieChart: React.FC<Props> = ({ home, away, width, height }) => {
  const ref = useRef(null);

  const radius = Math.min(width, height) / 2;
  const pie = d3.pie<Data>().value((d) => d.value);
  const arc = d3
    .arc<d3.PieArcDatum<Data>>()
    .innerRadius(radius * 0.65)
    .outerRadius(radius - 1);

  useEffect(() => {
    const svg = d3.select(ref.current);

    const pie_group = svg
      .append("g")
      .attr("transform", `translate(${width / 2},${height / 2})`);
    const data: Data[] = [
      { name: "Home", value: home },
      { name: "Away", value: away },
    ];
    const arcs = pie(data);

    function showTooltip(event: MouseEvent, d: any) {
      const tooltip = d3
        .select("body")
        .append("div")
        .attr("class", "tooltip")
        .style("position", "absolute")
        .style("background-color", "white")
        .style("padding", "10px")
        .style("border", "1px solid black")
        .style("border-radius", "5px")
        .style("pointer-events", "none")
        .style("opacity", 0);

      tooltip
        .html(`${d.data.value}%`)
        .style("left", event.pageX + 10 + "px")
        .style("top", event.pageY + 10 + "px")
        .transition()
        .duration(200)
        .style("opacity", 1);
    }

    function hideTooltip() {
      d3.select(".tooltip").remove();
    }

    pie_group
      .append("g")
      .selectAll("path")
      .data(arcs)
      .join("path")
      .attr("d", (d) => arc(d))
      .attr("fill", (d, i: number) => (i == 0 ? "#becbff" : "#0d0cb5"))
      .on("mouseover", function (event, d) {
        //d3.select(this).attr("opacity", 0.7);
        showTooltip(event, d);
      })
      .on("mouseout", function () {
        //d3.select(this).attr("opacity", 1);
        hideTooltip();
      });

    pie_group
      .selectAll("text")
      .data(arcs)
      .enter()
      .append("text")
      .attr("transform", (d) => `translate(${arc.centroid(d)})`)
      .attr("text-anchor", "middle")
      .attr("dy", "0.35em")
      .attr("fill", (d, i: number) => (i == 0 ? "black" : "white"))
      .text((d) => `${d.data.name}`); // Display label on top of each arc
    return () => {
      hideTooltip();
    };
  }, [home, away]);

  return <svg ref={ref} width={width} height={height}></svg>;
};

export default PieChart;
